module.exports = __webpack_public_path__ + "static/media/WhiteLogo.88a1ba9d.png";